import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { passwordService } from "../../../services/auth/password.service";
import { toast } from "react-hot-toast";
import { ArenaLogo } from "@/components/common/ArenaLogo";
import { Button } from "@/components/ui/button";

const ForgotPassword: React.FC = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);

    try {
      await passwordService.forgotPassword(email, "affiliate");
      toast.success("Password reset email sent successfully");
      navigate("/affiliate/auth/verify-otp", { state: { email } });
    } catch (error) {
      toast.error(
        error instanceof Error
          ? error.message
          : "Failed to send password reset email"
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className=" m-auto w-[98%]  md:w-max pt-4 md:pt-0 md:h-max">
      <div className="m-auto flex flex-col items-center justify-center md:w-5/6 w-11/12 px-5 md:py-7 py-6 bg-card border border-border rounded-[24px] shadow-[1px_5px_10px_0px_#D1D1D11A,4px_18px_19px_0px_#D1D1D117,9px_41px_25px_0px_#D1D1D10D,15px_73px_30px_0px_#D1D1D103,24px_115px_33px_0px_#D1D1D100]  ">
      <ArenaLogo className="w-12 border border-black mx-auto mb- rounded-[12px] bg-[#f6f6f6]" />
      <div className=" w-full space-y-8 last:space-y-4">
        <div>
          <h2 className="mt-6 font-bold text-[24px] text-foreground/60 leading-[24px] tracking-[0.16px] text-center align-middle">
            Forgot your password?
          </h2>
          <p className="mt-2 font-normal text-[14px] mt-4 tracking-normal text-center align-middle text-muted-foreground">
            Enter your email address and we'll send you a short code to verify
            your email.
          </p>
        </div>
        <form className="mt-8 space-y-6" onSubmit={handleSubmit}>
          <div className="rounded-md shadow-sm -space-y-px">
            <div className="grid gap-2">
              <label htmlFor="email">Email address</label>
              <input
                id="email"
                name="email"
                type="email"
                autoComplete="email"
                required
                className="appearance-none rounded-none relative block w-full px-3 py-2 border border-border placeholder-gray-500 text-foreground rounded-t-md focus:outline-none focus:ring-brand-500 focus:border-brand-500 focus:z-10 sm:text-sm"
                placeholder="your@email.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>
          </div>

          <div>
            <Button type="submit" size="lg" disabled={loading} className="w-full">
              {loading ? "Sending..." : "Send reset link"}
            </Button>
          </div>
        </form>
        <div className=" text-center">
            <Link
              to="/auth/login"
              className="text-sm text-brand-600 hover:text-brand-500 font-medium"
            >
              Back to Login
            </Link>
          </div>
      </div>
    </div>
    </div>
  );
};

export default ForgotPassword;
